import { FC, useMemo } from 'react';
import styles from './index.module.less';
import { formatPredictSale } from '@/common/components/business/AreaSalesPredict/V2Predict';

/**
 * @Description 营业预测额卡片-详情无总分五维/六维用
 */
const PredictSale:FC<{
  overviewData: any,
}> = ({
  overviewData
}) => {

  const predictSale = useMemo(() => {
    return formatPredictSale(overviewData);
  }, [overviewData]);

  return (
    <div className={styles.predictSale}>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/img_predictSale.png`} className={styles.predictSaleImg}/>

      <div className={styles.predictSaleContent}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/icon_turnover@3x.png`} className={styles.icon} />

        <div className={styles.total}>
          {predictSale.val}
          <div className={styles.totalUnit}>{predictSale.unit}</div>
        </div>

        <div className={styles.title}>{predictSale.title}</div>
      </div>
    </div>
  );
};

export default PredictSale;
